import type { AccessStateResponse, SubmitInquiryResponse } from '@assessments/shared'
import { apiFetch } from '../../services/apiClient.js'

export async function fetchAccessState(): Promise<AccessStateResponse> {
  const res = await apiFetch('/access-state')
  if (!res.ok) throw new Error(`Failed to load access state (${res.status})`)
  return (await res.json()) as AccessStateResponse
}

export async function submitInquiry(): Promise<SubmitInquiryResponse> {
  // apiFetch always sends a JSON content-type, and Fastify rejects an empty JSON body.
  const res = await apiFetch('/assessment-inquiries', { method: 'POST', body: '{}' })
  if (!res.ok) throw new Error(`Failed to submit inquiry (${res.status})`)
  return (await res.json()) as SubmitInquiryResponse
}
